import axios from "axios"
import { CONFIG } from "../constants/backendUrl"

const controller = CONFIG.webCrmUrl + '/webhook'
const token = CONFIG.webCrmWebhookToken

const headers = {
    Authorization: `Bearer ${token}`,
}

export const WebCrm_Webhook_API = {
    Request: {
        getPhotoByImplementerUUID: async (implementer_uuid) => {
            const resp = await axios.post(`${controller}/crm/download/implementer/photo/${implementer_uuid}`, {}, { headers, responseType: 'blob', })

            const blob = resp.data
            return await new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(blob)
                reader.onloadend = () => {
                    const result = reader.result
                    const base64 = result.split(',')[1]
                    resolve(base64)
                }
                reader.onerror = reject
            })
        },
    }
}